import { ref } from "vue";

const toasts = ref([]);
let nextToastId = 0;

export function useToast() {
  const show = ({
    tipo = "sucesso",
    titulo = "",
    mensagem = "",
    duracao = 5000,
    persist = false,
  }) => {
    if (persist && typeof window !== "undefined") {
      try {
        sessionStorage.setItem(
          "gex_toast_persist",
          JSON.stringify({ tipo, titulo, mensagem, duracao })
        );
      } catch (e) {
        console.warn("Erro ao persistir toast no sessionStorage:", e);
      }
      return;
    }

    const id = ++nextToastId;
    const toast = {
      id,
      tipo,
      titulo: titulo || getDefaultTitle(tipo),
      mensagem,
      duracao,
      criadoEm: Date.now(),
    };

    toasts.value.push(toast);

    if (duracao > 0) {
      setTimeout(() => {
        remover(id);
      }, duracao);
    }

    return id;
  };

  const remover = (id) => {
    const index = toasts.value.findIndex((t) => t.id === id);
    if (index !== -1) {
      toasts.value.splice(index, 1);
    }
  };

  const checkPersisted = () => {
    if (typeof window !== "undefined") {
      try {
        const persisted = sessionStorage.getItem("gex_toast_persist");
        if (persisted) {
          sessionStorage.removeItem("gex_toast_persist");
          const dados = JSON.parse(persisted);
          show(dados);
        }
      } catch (e) {
        sessionStorage.removeItem("gex_toast_persist");
      }
    }
  };

  function getDefaultTitle(tipo) {
    switch (tipo) {
      case "sucesso":
        return "Sucesso";
      case "erro":
        return "Erro";
      case "aviso":
        return "Atenção";
      case "info":
        return "Informação";
      default:
        return "";
    }
  }

  const sucesso = (mensagem, opcoes = {}) =>
    show({ tipo: "sucesso", mensagem, ...opcoes });
  const erro = (mensagem, opcoes = {}) =>
    show({ tipo: "erro", mensagem, ...opcoes });
  const aviso = (mensagem, opcoes = {}) =>
    show({ tipo: "aviso", mensagem, ...opcoes });
  const info = (mensagem, opcoes = {}) =>
    show({ tipo: "info", mensagem, ...opcoes });

  return {
    toasts,
    show,
    remover,
    checkPersisted,
    sucesso,
    erro,
    aviso,
    info,
  };
}
